"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Icon from "./icon.js";
export const TriangleFillIcon = React.forwardRef(function TriangleFillIcon(props, ref) {
    return (_jsx(Icon, Object.assign({ ref: ref }, props, { children: _jsx("path", { d: "M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z", fill: "currentColor" }) })));
});
export default TriangleFillIcon;
//# sourceMappingURL=triangle-fill.js.map